// Topbar.jsx
import React from "react";
import "./Topbar.css";
import { getUser } from '../../utils/auth';


const Topbar = ({ selectedTask, clearSelectedTask }) => {
  const user = getUser() || "Guest"

  return (
    <div className="topbar">
      <span className="username">👤 Hii, {user?.name}</span>

      {selectedTask && (
        <div className="task-summary">
          <span><strong>Task ID:</strong> {selectedTask.taskid}</span>
          <span><strong>Filename:</strong> {selectedTask.filename}</span>
          <span><strong>Status:</strong> {selectedTask.status}</span>
          <button
            className="btn-clear"
            onClick={clearSelectedTask}
            title="Clear task details"
          >
            ✖
          </button>
        </div>
      )}

      {/* <button className="logout-btn" onClick={onLogout}>
        🔓 Logout
      </button> */}
    </div>
  );
};

export default Topbar;
